/* Thin scroll indicator under the homepage product rails.
 *
 * gb-custom.css has styled .gb-cbar / .gb-cbar__thumb since the rails were
 * built, but the script that creates the element was never written, so no bar
 * has ever rendered. This is it.
 *
 * Why not the native scrollbar: the theme sets scrollbar-width on the scroller,
 * which makes Chromium ignore ::-webkit-scrollbar, so the native bar can't be
 * styled down to 1px. gb-custom.css hides it and we draw our own instead.
 *
 * The thumb's width is the visible fraction of the track, and its offset is the
 * scroll progress across the remaining space — so the thumb's right edge lands
 * exactly at the track's end when the rail is scrolled to the bottom.
 */
(() => {
  const RAIL = 'slideshow-component.resource-list__carousel';
  const SCROLLER = ':scope > slideshow-container > slideshow-slides';

  /** @param {HTMLElement} rail */
  function attach(rail) {
    if (rail.querySelector(':scope > .gb-cbar')) return;
    const scroller = rail.querySelector(SCROLLER);
    if (!scroller) return;

    const bar = document.createElement('div');
    bar.className = 'gb-cbar';
    const thumb = document.createElement('div');
    thumb.className = 'gb-cbar__thumb';
    bar.appendChild(thumb);
    rail.appendChild(bar);

    let queued = false;
    const render = () => {
      queued = false;
      const { scrollWidth, clientWidth, scrollLeft } = scroller;
      const overflow = scrollWidth - clientWidth;
      // nothing to scroll (or a single-column mobile view): keep the bar out of
      // the way rather than drawing a full-width thumb that can't move
      if (overflow <= 1) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';
      const ratio = clientWidth / scrollWidth;
      const thumbW = Math.max(ratio * 100, 4); // floor so it stays grabbable-looking
      const progress = scrollLeft / overflow;
      thumb.style.width = thumbW + '%';
      thumb.style.transform = `translateX(${progress * ((100 / thumbW) * 100 - 100)}%)`;
    };

    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(render);
    };

    scroller.addEventListener('scroll', schedule, { passive: true });
    new ResizeObserver(schedule).observe(scroller);
    render();
  }

  const init = () => document.querySelectorAll(RAIL).forEach(attach);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // section re-render in the theme editor replaces the rail wholesale
  document.addEventListener('shopify:section:load', init);
})();
